export default __webpack_public_path__ + "static/media/e_wdt_c_4_5.5c38b6f1.mp3";